/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useAuth } from '../../../../app/modules/auth'
import ChangePassword from '../../../../app/modules/auth/components/ChangePassword'
import { queryCache, queryClient } from '../../../../queries/client'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Link, useMatch, useNavigate } from 'react-router-dom'
import { useCanUserAccess } from '../../../../app/pages/store/userRoleGrants'
import SyncInvestorCompanies from '../../../../app/pages/accounts/components/SyncInvestorCompanies'
import { generateRedirectUrl, useLogout } from '../../../../app/modules/auth/core/_requests'
import Avatar from '../../../layout/components/header/Avatar'
import useIsMobile from '../../../../utils/detectDevice'
import { Icon } from '@iconify/react'
import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/20/solid'
import { LogoutModal } from '../../../layout/components/header/LogoutModal'

const HeaderUserMenu: FC<{ userName: string; userEmail: string; profileImage?: string }> = ({
  userName,
  userEmail,
  profileImage,
}) => {
  const { logout } = useAuth()
  const loginMutation = useLogout()
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [showSyncInvestors, setShowSyncInvestors] = useState(false)
  const isAdmin = useCanUserAccess('*', '*')

  const { isMobile } = useIsMobile(1024)
  const [dialogLogout, setDialogLogout] = useState(false)
  const [activeItem, setActiveItem] = useState<string | null>(null)

  const logoutMutation = useLogout()

  function handleLogout() {
    logoutMutation.mutate(
      {},
      {
        onSuccess: () => {
          queryCache.clear()
          logout()
          window.location.href = '/auth'
          sessionStorage.clear()
          queryClient.invalidateQueries()
          queryClient.clear()
          const redirectUrl = generateRedirectUrl()
          window.location.href = redirectUrl
        },
        onError: (error) => {
          console.error('Failed to logout:', error)
        },
      }
    )
    document.location.reload()
  }

  const routes = [
    ...(isAdmin
      ? [
          {
            name: 'User Management',
            onClick: () => {
              navigate('/userManagement')
            },
            type: 'iconify',
            icon: 'mdi:users',
          },
        ]
      : []),
    {
      name: 'Log Out',
      onClick: () => {
        setDialogLogout(true)
      },
      type: 'heroIcon',
      icon: ArrowLeftStartOnRectangleIcon,
    },
  ]

  return (
    <div
      className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-325px shadow-sm pt-1 pb-1 border border-gray-300 ${
        isMobile ? 'mt-10' : 'mt-3'
      }`}
      data-kt-menu='true'
    >
      <div className='menu-item p-0 px-2 bg-gray-100 d-flex items-center'>
        <div className='menu-content d-flex align-items-center px-5'>
          <div className='symbol symbol-50px me-5'>
            <Avatar name={userName || ''} profileImage={profileImage} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{userName}</div>
            <p className='fs-base text-gray-600'>{userEmail}</p>
          </div>
        </div>
      </div>

      <div className='separator'></div>

      <div className='p-2 px-3 cursor-pointer'>
        {routes.map((item) => (
          <div key={item.name} className='menu-item'>
            <a
              onClick={() => {
                item.onClick()
              }}
              onMouseEnter={() => setActiveItem(item.name)}
              onMouseLeave={() => setActiveItem(null)}
              className='menu-link px-3 text-gray-800 text-hover-primary'
            >
              <button
                className={`btn btn-sm btn-icon text-gray-700 text-hover-primary menu-icon ${
                  activeItem === item.name ? 'bg-white' : 'bg-secondary'
                }`}
                style={{ width: '3.50rem', height: '3.50rem' }}
                type='button'
                aria-hidden='true'
              >
                {item?.type !== 'iconify' && (
                  <item.icon
                    className={`btn btn-sm btn-icon menu-icon ms-1 ${
                      activeItem === item.name
                        ? 'bg-white text-primary'
                        : 'bg-secondary text-gray-700'
                    }`}
                    style={{ width: '2rem', height: '2rem' }}
                    aria-hidden='true'
                  />
                )}
                {item?.type === 'iconify' && typeof item.icon === 'string' && (
                  <Icon
                    icon={item.icon || ''}
                    className={`btn btn-sm btn-icon menu-icon ms-2 ${
                      activeItem === item.name
                        ? 'bg-white text-primary'
                        : 'bg-secondary text-gray-700'
                    }`}
                    style={{ width: '2rem', height: '2rem' }}
                  />
                )}
              </button>
              <div className='ms-3 d-flex align-items-center fs-5'>{item.name}</div>
            </a>
          </div>
        ))}
      </div>

      {/* {isAdmin && (
        <div className='menu-item px-5'>
          <Link to='/addAccount' className='menu-link px-5'>
            Add Account
          </Link>
        </div>
      )} */}

      {/* {isAdmin && (
        <div className='menu-item px-4'>
          <Link to='/userManagement' className='menu-link px-3'>
            <button
              className='btn btn-sm btn-icon bg-secondary bg-hover-white text-hover-primary me-2 menu-icon'
              type='button'
            >
              <i className='bi bi-people-fill fs-2 ' />
            </button>
            <div>
              <p className='mb-0'>User Management</p>
              <div className='fs-8 text-muted'>Manage Investor & companies</div>
            </div>
          </Link>
        </div>
      )} */}

      {/* {isAdmin && (
        <div className='menu-item px-5'>
          <Link to='/addInvestor' className='menu-link px-5'>
            Add Investor/Fund
          </Link>
        </div>
      )}

      {isAdmin && (
        <div className='menu-item px-5'>
          <span
            className='menu-link px-5'
            onClick={() => setShowSyncInvestors(true)}
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            Sync Investors
          </span>
        </div>
      )}

      {isAdmin && (
        <div className='menu-item px-5'>
          <Link to='/adduser' className='menu-link px-5'>
            Add Another User
          </Link>
        </div>
      )} */}

      {/* {
        <div className='menu-item px-4'>
          <span
            className='menu-link px-3'
            onClick={() => setShowModal(true)}
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            <button
              className='btn btn-sm btn-icon bg-secondary bg-hover-white text-hover-primary me-2 menu-icon'
              type='button'
            >
              <KTSVG
                className='svg-icon-1'
                path='/media/icons/duotune/general/change-password.svg'
              />
            </button>
            <div>
              <p className='mb-0'>Change Password</p>
              <div className='fs-8 text-muted'>Change your password</div>
            </div>
          </span>
        </div>
      } */}

      {/* <div className='menu-item px-4'>
        <a
          onClick={() => {
            loginMutation.mutate(
              {},
              {
                onSuccess: () => {
                  queryCache.clear()
                  logout()
                  window.location.href = '/auth/login'
                },
              }
            )
          }}
          onMouseEnter={() => setIsActive(true)}
          onMouseLeave={() => setIsActive(false)}
          className='menu-link px-3'
        >
          <button
            className={`btn btn-sm btn-icon  text-hover-primary me-2 menu-icon ${
              isActive ? 'bg-white' : 'bg-secondary'
            }`}
            style={{ width: '3.75rem', height: '3.75rem' }}
            type='button'
            aria-hidden='true'
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/logout.svg' />
          </button>
          Log Out
        </a>
      </div> */}

      {showModal && (
        <ChangePassword
          show={showModal}
          handleClose={() => {
            setShowModal(false)
          }}
        />
      )}
      {showSyncInvestors && (
        <SyncInvestorCompanies
          show={showSyncInvestors}
          handleClose={() => setShowSyncInvestors(false)}
        />
      )}
      {dialogLogout && (
        <LogoutModal
          showModal={dialogLogout}
          handleBack={() => setDialogLogout(false)}
          handleSubmit={() => handleLogout()}
        />
      )}
    </div>
  )
}

export { HeaderUserMenu }
